// Mirrors services/shared/roles.py ROLE_RANK (source of truth, imported by core and moderation).
const RANK: Record<string, number> = { admin: 100, advisor: 50, tester: 10 };
export function roleRank(role: string): number { return RANK[role] ?? 0; }
export function roleSatisfies(role: string, required: string): boolean {
  return roleRank(role) >= roleRank(required);
}
